module.exports = __webpack_public_path__ + "img/videodefault.fe59692d.gif";